import script from "./DeviceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceCard.vue?vue&type=script&setup=true&lang=js"

import "./DeviceCard.vue?vue&type=style&index=0&id=48f7c182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f7c182"]])

export default __exports__